/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 16:59:14
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-30 16:25:11
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Radio/Radio.tsx
 */
import React, { ReactNode } from 'react';
import { Radio as RadioAntd } from 'antd';
interface IProps {
  onChange?: (e) => void;
  className?: string;
  value?: string | number;
  radioList: RadioList[];
  disabled?: boolean;
}
interface RadioList {
  value: string | number | boolean;
  disable?: boolean;
  label: ReactNode | string;
  className?: string;
  disabled?: boolean;
}
const Radio = (props: IProps) => {
  const { onChange, className, value, radioList, disabled } = props;

  return (
    <RadioAntd.Group
      className={className}
      onChange={onChange}
      value={value}
      disabled={disabled}>
      {radioList.map((item) => (
        <RadioAntd
          value={item.value}
          key={`${item.value} + ${item.label}`}
          disabled={item.disable || item.disabled}
          className={item.className}>
          {item.label}
        </RadioAntd>
      ))}
    </RadioAntd.Group>
  );
};
const RadioGroup = (props) => {
  const { onChange, className, value, children, ...rest } = props;
  return (
    <RadioAntd.Group
      className={className}
      onChange={onChange}
      value={value}
      {...rest}>
      {children}
    </RadioAntd.Group>
  );
};
const RadioItem = (props) => {
  const { children, ...rest } = props;
  return <RadioAntd {...rest}>{children}</RadioAntd>;
};
export { RadioGroup, RadioItem };
export default Radio;
